<template>
    <v-card flat class="trans">
        <v-card flat class="score-chart" :class="{'header': xl, 'header-lg': lg}">
            <v-container>
                <div class="flex-ctr">                    
                    <span class="mr-2"><span style="font-weight: bold;">Added in week</span></span>
                    <span class="number mr-2">{{ this.getPreviousWeekNumber() }}</span>
                    <span style="font-size: small;" v-if="new_accos.length!==0">(+{{ this.new_accos.length }})</span> 
                    <span style="font-size: small;" v-else>(+0)</span>  
                    <div style="margin-left:auto;  margin-right: 8px;">
                        <v-icon medium color="green" v-on:click="showDialog()">mdi-microsoft-excel</v-icon>
                    </div>         
                    <!-- <div style="margin-right: 8px;">
                        <div v-if=loading>
                            <v-progress-circular :width="3" :size="20" color="success" indeterminate></v-progress-circular>
                        </div>
                        <div v-else> 
                            <v-icon medium color="green" v-on:click="exportDataToExcel()">mdi-microsoft-excel</v-icon>
                        </div>
                    </div>                                        -->
                </div>                   
                <div class="mock-href" @click="hideThisList()">Hide me for this week</div>     
            </v-container>
        </v-card>
        <div class="wrapper">
            <v-card flat class="acco-list acco-list2 pa-0 ma-0 mt-2">
                <div v-if="new_accos.length!==0">
                    <ul class="ul scrollbar-hide" :class="{'ul-xl': xl, 'ul-lg': lg}">
                        <li v-for="(acco, i) in new_accos" :key="i">  
                            <v-card class="acco-card">                                        
                                <div class="flex">
                                    <img :src="acco.hsft_foto" width="95vw" height="80vh"/>                                            
                                    <v-card fluid flat width="100%" class="trans">
                                        <div @click="$router.open('/huis/onHuis/' + acco.encrid)" class="ml-2 mt-1 flex-btm">
                                            <div><a>{{ acco.huis_code }}</a></div>
                                            <v-icon :size="20" class="ml-3">mdi-account</v-icon>
                                            <div class="ml-1" style="font-size: 11pt;">{{ acco.max_pers }}</div>

                                        </div>
                                        <div class="d-date ml-2"><b>{{ acco.huis_naam }}</b></div>
                                        <div class="d-date ml-2">{{ acco.huis_hbes_kort }}</div>
                                    </v-card>
                                </div>
                                <div class="flex-btm">
                                    <v-rating small color="warning" v-model="acco.huis_ster" dense ></v-rating>
                                    <div class="d-date"><b>{{ acco.gebr_naam }}</b></div>
                                </div>
                                <v-divider></v-divider>
                                <div class="flex">
                                <div>
                                    <div class="d-date mt-1">Badkamers {{ acco.huis_aantBadkamer }}, Slaapkamers {{ acco.huis_aantSlaapkamer }}</div>
                                    <div class="d-date mb-1">Locatie: {{ acco.huis_plaats }}</div>
                                </div>
                                <div class="visit-me">
                                    <div class="flex-col" @click="loadVfyPage(acco.external_url)">
                                        <div>visit me</div><v-icon>mdi-web</v-icon><div>on the web</div>
                                    </div>
                                </div>
                                </div>
                                <v-divider></v-divider>                                   
                                <div class="d-date-xs"> Live since {{ acco.stat_d_date }}</div>                                                   
                            </v-card>
                        </li>
                    </ul>
                </div>          
                <div v-else>
                    <div v-if="loadinglist"></div>
                    <v-container v-else class="errorcontainer">
                        <v-card flat fluid class="pa-4 ma-4 errorcard">
                            <div class="flex-oops">
                                <img src="@/assets/dashboard/desert.svg" class="img-oops"/>
                                <p class="text-center">No accommodations added in week {{ this.getPreviousWeekNumber() }}.</p>
                            </div>
                        </v-card>
                    </v-container>
                </div>              
            </v-card>
        </div>
        <oldweeks ref="oldweeks"></oldweeks>
    </v-card>
</template>

<script>
import oldweeks from '@/views/syst/dashboard/cards/week_overview.vue'
export default {
    data() {
        return {
            loading: false,
            loadinglist: true,
            new_accos: [],
        }
    },
    components: {
        oldweeks,
    },    
    created(){ 

    },                  
    mounted(){            
        this.getNewAccos()
    },    
    computed: {
        xs: function(){
            return this.$vuetify.breakpoint.name === 'xs';
        },
        sm: function(){
            return this.$vuetify.breakpoint.name === 'sm';
        },                
        lg: function(){
            return this.$vuetify.breakpoint.name === 'lg';
        },                
        xl: function(){
            return this.$vuetify.breakpoint.name === 'xl';
        }                
    },       
    methods:{
        showDialog(){
            this.$refs.oldweeks.open()
        },
        getPreviousWeekNumber(){
            let w = this.$moment(new Date()).isoWeek() - 1
            return w===0?this.$moment(new Date((new Date().getFullYear() - 1), 11, 31, 0, 0, 0)).isoWeek():w
        },
        getThisWeekNumber(){
            return this.$moment(new Date()).isoWeek()
        },
        getStartDateLastWeekIso(){
            let w = this.$moment(new Date()).isoWeek()
            let y = new Date().getFullYear
            if(w === 0){
                y = y - 1
                w = this.$moment(new Date(y, 11, 31, 0, 0, 0)).isoWeek()
            } else {
                w = w - 1
            }
            return this.$moment().year(y).week(w).day(1).format('YYYY-MM-DD')
        },
        loadVfyPage(url){
            window.open(url);
        },        
        exportDataToExcel() {
            console.log('export function')
            this.loading = true;
            this.$axios
                .post("ares/json/ares/syst/dashboard/exportNewAccolist.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        week: this.getPreviousWeekNumber(),
                        request: "export"
                    },
                    export: this.new_accos,
                })
                .then(res => {
                    if (res.data.error) {
                        this.loading = false;
                        console.log(res.data.error);
                    } else {
                        this.loading = false;
                        this.items = res.data.export;
                        window.open(this.items.filename, '_blank');
                    }
                })
        },
        getEndDateLastWeekIso(){
            let w = this.$moment(new Date()).isoWeek()
            let y = new Date().getFullYear
            if(w === 0){
                y = y - 1
                w = this.$moment(new Date(y, 11, 31, 0, 0, 0)).isoWeek()
            } else {
                w = w - 1
            }            
            return this.$moment().year(y).week(w).day(7).format('YYYY-MM-DD')
        },
        hideThisList(){
            localStorage.setItem('newacco.hide', this.getPreviousWeekNumber().toString())
            this.$emit('hide', true);
        },
        getNewAccos(){
            this.$axios
                .post("ares/json/ares/syst/dashboard/getNewAccommodationPerWeek.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "getNewAccommodationPerWeek"
                },
                getNewAccommodationPerWeek: {
                    startdate: this.getStartDateLastWeekIso(),
                    enddate: this.getEndDateLastWeekIso(),
                }
                })
                .then(res => {
                    if (res.data.error) {
                        this.loadinglist=false;
                        console.log(res.data.error);
                    } else {
                        this.loadinglist=false;
                        this.new_accos = res.data.accos;

                    }
                })
        }
    }
}        
</script>

<style scoped>
.flex{
    display: flex;
    flex-direction: row;
    align-items: top;
}
.errorcontainer{
    height: 100vh;
}
.errorcard{
    background-color: transparent;
}
.flex-oops{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
.img-oops{
    height: 10vh !important;
}
.flex-ctr{
    display: flex;
    flex-direction: row;
    align-items: center;
}
.mock-href{
    color: blue;
    text-decoration: underline;
    font-size: 8pt;
    cursor: pointer;
}    
.flex-col{
    display: flex;
    flex-direction:column;
    align-items: center;
}
.visit-me{
    margin-left:auto; 
    margin-right: 10px; 
    font-size: 7pt;
    cursor: pointer;
}
.flex-btm{
    display: flex;
    flex-direction: row;
    align-items: baseline;
}
.acco-list{
    margin-top: 5px;
    width: 100%;
}
.acco-card{
    margin-bottom: 12px;
    border-radius: 10px !important;
    border: 1px solid lightgrey !important;
    background-color: rgba(239, 239, 240, 0.9);
}
.d-date{
    margin-left: 5px;
    font-size: 10pt;
}
.d-date-xs{
    margin-left: 5px;
    font-size: 8pt;
}

.trans{
    background-color: transparent !important;
}
.acco-list2{
    background-color: transparent !important;
}
.header{
    border: 1px solid rgba(50,205,50,0.5);
    height: 8vh;
}
.header-lg{
    border: 1px solid rgba(50,205,50,0.5);
    height: 10vh;
}
.wrapper{
    position: relative;    
}
.number{
    font-size: 18pt;
    font-weight: 700;
    color: green;
}
.ul {
    list-style-type: none !important;
    position:absolute;
    left: 0;
    right: 0;
    top: 0;
    padding: 0px 0px;
    margin: 0;
    overflow-y: auto;
    border: none;
  }
img {
    border-top-left-radius: 10px;    
}
.ul-xl{
    height: 81.5vh;
}
.ul-lg{
    height: 77vh;
}
.score-chart {
    background: url('../assets/not_a_sunset.png') !important;
    background-size: cover !important;
}
.scrollbar-hide::-webkit-scrollbar {
    display: none;
}  
.scrollbar-hide {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}      
</style>